import { gql } from '@apollo/client';

import { TPayment } from 'types';

export interface IGetActivePaymentsResponse {
  activeWorkShift: {
    payments: Array<TPayment>;
  };
}
export const GET_ACTIVE_PAYMENTS = gql`
  query activeWorkShift {
    activeWorkShift {
      payments {
        id
        sum
        sums {
          deposit
          bonus
          promo_code
          cashback
        }
        bonus
        method
        is_refunded
        not_refundable
        created_at
        client_session {
          hosts {
            finished_at
            started_at
            host {
              alias
            }
          }
          started_at
          finished_at
        }
        client {
          uuid
          nickname
          phone
        }
        card_sum
        cash_sum
        items {
          id
          amount
          type
          sum
          entity {
            ... on Service {
              id
              title
              cost
              vat
              tax_system
            }
            ... on Good {
              id
              title
              cost
              amount
              vat
              tax_system
            }
            ... on Tariff {
              id
              title
              disable_sale_receipt_printing
            }
          }
        }
        status
      }
    }
  }
`;
